import { DOCUMENT } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core'
import { HttpClient } from '@angular/common/http'

@Component({
  selector: 'ezy-icons',
  template: `<ng-content></ng-content>`,
  styles: [''],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EzyIconsComponent implements OnInit {
  @Input()
  set src(src: string) {
    if (src) {
      const fileContent = this.httpClient.get(src, { responseType: 'text' }).subscribe(val => {
        this.element.nativeElement.innerHTML = val
      })
    }
  }

  @Input()
  set name(name: string) {
    if (name) {
      const src = `/assets/icons/${name}.svg`
      const fileContent = this.httpClient.get(src, { responseType: 'text' }).subscribe(val => {
        this.element.nativeElement.innerHTML = val
      })
    }
  }
  constructor(
    private element: ElementRef,
    private httpClient: HttpClient
  ) { }

  ngOnInit(): void { }
}
